module.exports = __webpack_public_path__ + "img/u1190.d9ff09d3.svg";